import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { IconRemove } from '../../../components/icons/IconRemove';
import { ThreadOptionsStructure } from '../ThreadOptionStructure';
import type { AdminMessageRemoverProps } from './AdminMessageRemover';
import { AdminMessageRemover } from './AdminMessageRemover';

const messages = defineMessages({
  deleteLabel: { defaultMessage: 'Supprimer le message', id: 'lmA0Bs' },
  as: { defaultMessage: "en tant qu'administateur", id: 'j/iQb4' },
  asModerator: { defaultMessage: 'en tant que modérateur', id: 'JyfYNh' },
});

export const AdminDeleteMessageOption: React.FC<AdminMessageRemoverProps> = props => {
  return (
    <AdminMessageRemover {...props}>
      <ThreadOptionsStructure
        icon={<IconRemove size="m" />}
        title={<FormattedMessage {...messages.deleteLabel} />}
        subtitle={
          <FormattedMessage {...(props.asModerator ? messages.asModerator : messages.as)} />
        }
      />
    </AdminMessageRemover>
  );
};
